import request from '@/utils/request'

/**
 * 地区树
 * @param data
 * @returns {*}
 */
export function addressTree(data) {
    return request({
        url: '/address/get/tree',
        method: 'post',
        data
    })
}

/**
 * 材质树
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function textureCategoryTree(data) {
    return request({
        url: '/sys/texture/category/getTree',
        method: 'post',
        data
    })
}

/**
 * 获取工艺分类
 * @returns {*}
 */
export function technicCategoryAll() {
    return request({
        url: '/api/technic/category/list',
        method: 'post'
    })
}

/**
 * 获取工艺
 * @param categoryId
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function technicByCategory(categoryId) {
    return request({
        url: `/api/technic/getBy/${categoryId}`,
        method: 'get',
    })
}

/**
 * 工艺树
 * @returns {*}
 */
export function technicTree(data) {
    return request({
        url: `/sys/technic/getTree`,
        method: 'post',
        data
    })
}

/**
 * 产品类别
 * @param data
 * @returns
 */
export function productCategoryTree(data) {
    return request({
        url: `/api/company/product/getCategories`,
        method: 'post',
        data
    })
}

/**
 * 获取资质树
 * @param data
 * @returns
 */
export function qualificationCategoryTree(data) {
    return request({
        url: `/api/sys/qualification/category/getTree`,
        method: 'post',
        data
    })
}

/**
 * 与某个企业的收藏关系
 * @param id
 * @returns {*}
 */
export function collectionRelation(id) {
    return request({
        url: `/api/interaction/collectedRelation/${id}`,
        method: 'get',
    })
}

/**
 * 收藏某个企业
 * @param id
 * @returns {*}
 */
export function collectionEnterprise(id) {
    return request({
        url: `/api/enterprise/collected/${id}`,
        method: 'post',
    })
}

/**
 * 取消收藏某个企业
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function cancelCollection(id) {
    return request({
        url: `/api/interaction/cancelCollected/${id}`,
        method: 'post',
    })
}

/**
 * 收藏某个产品
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function collectionProduct(id) {
    return request({
        url: `/api/company/product/home/collectionProduct/${id}`,
        method: 'post',
    })
}

/**
 * 与某个产品的收藏关系
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function collectionProductRelation(id) {
    return request({
        url: `/api/company/product/home/collectionRelation/${id}`,
        method: 'post',
    })
}

/**
 * 取消收藏某个产品
 * @param id
 * @returns {Promise<axios.AxiosResponse<any>> | *}
 */
export function cancelCollectionProduct(id) {
    return request({
        url: `/api/company/product/home/cancelCollection/${id}`,
        method: 'post',
    })
}

//内容管理
export function websiteContentList(data) {
    return request({
        url: '/website/content/list',
        method: 'post',
        data
    })
}
export function websiteContentList4Common(data) {//常见问题
    return request({
        url: '/website/content/list/common',
        method: 'post',
        data
    })
}
export function websiteContentList4Popular(data) {//热门问题
    return request({
        url: '/website/content/list/popular',
        method: 'post',
        data
    })
}
export function websiteContentInfo4Categort(data) {
    return request({
        url: '/website/content/getByCategory',
        method: 'post',
        data
    })
}
export function websiteContentViewCount(id) {
    return request({
        url: `/website/content/viewCount/${id}`,
        method: 'get',
    })
}
export function websiteContentCategoryTree(data) {
    return request({
        url: '/website/content/category/tree',
        method: 'post',
        data
    })
}
export function websiteContentCategoryTreeCategory(data) {
    return request({
        url: '/website/content/category/tree/category',
        method: 'post',
        data
    })
}

/**
 * 热门搜索
 * @param data
 * @returns {*}
 */
export function recordKeyword(data) {
    return request({
        url: '/api/search/keyword/record',
        method: 'post',
        data
    })
}

/**
 * 热门搜索关键字
 * @param data
 * @returns {*}
 */
export function hotKeywords(data) {
    return request({
        url: '/api/search/keyword/hot',
        method: 'post',
        data
    })
}

// 企业信息
export function enterpriseShort(id) {
    return request({
        url: `/api/enterprise/home/showBy/${id}`,
        method: 'get',
    })
}

export function enterpriseUser(params) {//企业下联系人
    return request({
        url: `/api/user/list/enterpriseId`,
        method: 'get',
        params
    })
}

export function contactUs(data) {//联系我们
    return request({
        url: '/message/consultation/save',
        method: 'post',
        data
    })
}
export function readNum(id) {//内容已读++
    return request({
        url: `/website/content/viewCount/${id}`,
        method: 'get',
    })
}

